@if (!showForgotPassword()) {
  <form class="login-dialog" [formGroup]="loginForm">
    <div class="login-dialog__header">
      <p class="login-dialog__subtitle">Enter your credentials to access your account</p>
    </div>

    <div class="login-dialog__fields">
      <div class="login-dialog__field">
        <label for="username" class="login-dialog__label">Username</label>
        <input
          id="username"
          type="text"
          formControlName="username"
          class="login-dialog__input"
          [class.login-dialog__input--invalid]="usernameControl?.invalid && usernameControl?.touched"
          placeholder="Enter your username"
        />
        @if (usernameControl?.invalid && usernameControl?.touched) {
          @if (usernameControl?.errors?.['required']) {
            <div class="login-dialog__error">Username is required</div>
          }
        }
      </div>

      <div class="login-dialog__field">
        <label for="password" class="login-dialog__label">Password</label>
        <input
          id="password"
          type="password"
          formControlName="password"
          class="login-dialog__input"
          [class.login-dialog__input--invalid]="passwordControl?.invalid && passwordControl?.touched"
          placeholder="Enter your password"
        />
        @if (passwordControl?.invalid && passwordControl?.touched) {
          @if (passwordControl?.errors?.['required']) {
            <div class="login-dialog__error">Password is required</div>
          }
          @if (passwordControl?.errors?.['minlength']) {
            <div class="login-dialog__error">Password must be at least 6 characters</div>
          }
        }
        <div class="login-dialog__forgot">
          <button type="button" tuiButton appearance="flat" class="login-dialog__link login-dialog__link--small" (click)="openForgotPassword()">
            Forgot password?
          </button>
        </div>
      </div>
    </div>

    @if (turnstileEnabled()) {
      <div class="login-dialog__captcha">
        <app-turnstile-widget
          #turnstileWidget
          action="login"
          (tokenReceived)="onTurnstileToken($event)"
          (tokenExpired)="onTurnstileExpired()"
          (errorOccurred)="onTurnstileError($event)"
        />
      </div>
    }

    <div class="login-dialog__actions login-dialog__actions--primary">
      <button type="submit" tuiButton size="l" [appearance]="submitAppearance" class="login-dialog__submit" (click)="onSubmit()" [disabled]="submitDisabled">
        @if (loading()) {
          <span>Signing in...</span>
        } @else {
          <span>Sign In</span>
        }
      </button>
    </div>

    <div class="login-dialog__footer">
      <span class="login-dialog__footer-text">Don't have an account?</span>
      <button type="button" tuiButton appearance="flat" size="s" class="login-dialog__link" (click)="openRegisterDialog()">
        Sign Up
      </button>
    </div>
  </form>
} @else {
  <div class="login-dialog forgot-dialog">
    @if (!forgotSent()) {
      <div class="login-dialog__header">
        <h2 class="login-dialog__title">Reset password</h2>
        <p class="login-dialog__subtitle">Enter your email address and we'll send you a reset link.</p>
      </div>

      <form [formGroup]="forgotForm" class="login-dialog__fields">
        <div class="login-dialog__field">
          <label for="forgot-email" class="login-dialog__label">Email</label>
          <input
            id="forgot-email"
            type="email"
            formControlName="email"
            class="login-dialog__input"
            [class.login-dialog__input--invalid]="forgotEmailControl?.invalid && forgotEmailControl?.touched"
            placeholder="Enter your email address"
          />
          @if (forgotEmailControl?.invalid && forgotEmailControl?.touched) {
            @if (forgotEmailControl?.errors?.['required']) {
              <div class="login-dialog__error">Email is required</div>
            }
            @if (forgotEmailControl?.errors?.['email']) {
              <div class="login-dialog__error">Enter a valid email address</div>
            }
          }
        </div>
      </form>

      <div class="login-dialog__actions">
        <button type="button" tuiButton appearance="outline" (click)="backToLogin()">
          Back
        </button>
        <button type="button" tuiButton (click)="submitForgotPassword()" [disabled]="loading()">
          @if (loading()) {
            <span>Sending...</span>
          } @else {
            <span>Send reset link</span>
          }
        </button>
      </div>
    } @else {
      <div class="login-dialog__header">
        <h2 class="login-dialog__title">Check your email</h2>
        <p class="login-dialog__subtitle">If an account with that email exists, a reset link has been sent. Check your inbox.</p>
      </div>
      <div class="login-dialog__actions login-dialog__actions--center">
        <button type="button" tuiButton (click)="backToLogin()">Back to Sign In</button>
      </div>
    }
  </div>
}

<ng-template #verificationAlertTemplate="polymorpheus" polymorpheus>
  @if (!verificationSent()) {
    <div class="verification-alert">
      <span>Your email address is not verified. Please check your inbox for the verification link.</span>
      <button
        tuiLink
        type="button"
        [disabled]="sendingVerification()"
        (click)="resendVerificationEmail()"
      >
        @if (sendingVerification()) {
          Sending...
        } @else {
          Resend verification email
        }
      </button>
    </div>
  } @else {
    <span>Verification email sent! Check your inbox.</span>
  }
</ng-template>
